import {fetchGet, generateEndpoint} from "../utils/request";

export const getCategories = async() => {
  const url = `${generateEndpoint("getCategories")}`;
  return fetchGet(url, null);
};
